import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`1. Finalize the schedule & mode of delivery for the workshop`}</h3>
    <ul>
      <li parentName="ul">{`Webex: 4 days x 2.5hours`}</li>
      <li parentName="ul">{`Self Paced`}</li>
      <li parentName="ul">{`In Person: 1 day x 8.5 hours`}</li>
    </ul>
    <h3>{`2. Identify primary mentor for the journey`}</h3>
    <h3>{`3.  Collect the data required for the sessions from the participants`}</h3>
    <p><a parentName="p" {...{
        "href": "/ibm-cloudnative-journey/5f7c93ea7da72473d04e461e77dbcf08/Participant_Data_Sheet.xlsx"
      }}>{`Participant Data Collection Sheet`}</a></p>
    <h3>{`4.  Github setup:`}</h3>
    <ul>
      <li parentName="ul">{`Create a github organization: `}<strong parentName="li">{`SI-Name`}</strong>{`-sandbox-team-n..`}</li>
      <li parentName="ul">{`Add all participants as members of the organization.`}</li>
    </ul>
    <h3>{`5. Slack Channel Setup`}</h3>
    <p>{`Set up a new slack channel (`}<strong parentName="p">{`SI-Name`}</strong>{`-cloudnative) and add all participants`}</p>
    <h3>{`6. IBM Cloud Setup:`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Create resource group `}<strong parentName="p">{`sandbox-team-n..`}</strong>{` under the SI Account to be used for the worksop`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Create access groups `}<strong parentName="p">{`SANDBOX-TEAM-N..-ADMIN`}</strong>{` and `}<strong parentName="p">{`SANDBOX-TEAM-N..-USER`}</strong>{` and make all users part of the SANDBOX-TEAM-ONE-USER group.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Run these scripts to create access groups from iteration-zero repository`}</p>
      </li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`./acp-admin.sh SANDBOX-TEAM-ONE-ADMIN sandbox-team-one
./acp-user.sh SANDBOX-TEAM-ONE-USER sandbox-team-one us-east
`}</code></pre>
    <ul>
      <li parentName="ul">{`Board all users by adding them to access group SANDBOX-TEAM-N..-USER `}</li>
    </ul>
    <h3>{`7. Cluster Setup:`}</h3>
    <ul>
      <li parentName="ul">{`Setup a redhat openshift cluster (sandbox-ocp43-n..) in London datacenter with 3 worker nodes (16 cores x 32 GB)`}</li>
    </ul>
    <h3>{`8. Cloud Native Toolkit Setup:`}</h3>
    <p>{`a) Install Cloud Native toolkit onto the OCP Cluster (Follow instructions outlined in `}<a parentName="p" {...{
        "href": "https://cloudnativetoolkit.dev/admin/installation-existing"
      }}>{`https://cloudnativetoolkit.dev/admin/installation-existing`}</a>{`)`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/IBM/ibm-garage-tekton-tasks/tree/master"
        }}>{`Install Tekton tasks`}</a></li>
      <li parentName="ul">{`[Artifactory Post Install Setup]`}{` (`}<a parentName="li" {...{
          "href": "https://cloudnativetoolkit.dev/admin/artifactory-setup"
        }}>{`https://cloudnativetoolkit.dev/admin/artifactory-setup`}</a>{`)`}</li>
      <li parentName="ul">{`[argocd Post Install Setup]`}{` (`}<a parentName="li" {...{
          "href": "https://cloudnativetoolkit.dev/admin/argocd-setup"
        }}>{`https://cloudnativetoolkit.dev/admin/argocd-setup`}</a>{`)`}</li>
      <li parentName="ul">{`[Install Codeready workspaces]`}{` (`}<a parentName="li" {...{
          "href": "https://cloudnativetoolkit.dev/admin/config-install#codeready-workspace-installation"
        }}>{`https://cloudnativetoolkit.dev/admin/config-install#codeready-workspace-installation`}</a>{`)`}</li>
    </ul>
    <p>{`b) Customize dashboard to include crw, github links (replace links for your cluster)`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`igc tool-config --name sysdig --url https://us-east.monitoring.cloud.ibm.com/api/oauth/openid/IBM/0f42478cb66d4ce0b11c9168b02c5690/e0caebc1-92c0-46a5-b6d0-ef4ba28bd5ed
igc tool-config --name logdna --url https://app.us-east.logging.cloud.ibm.com/ext/ibm-sso/38d0b85d06
igc tool-config --name ir --url https://cloud.ibm.com/kubernetes/registry/main/start
igc tool-config --name github --url https://github.com/ibm-workshop-team-one
igc tool-config --name codeready --url https://codeready-codeready.workshop-ocp43-one-3b1fc50af0b2002f0241bdf5d2432efd-0000.sjc03.containers.appdomain.cloud/dashboard/
`}</code></pre>
    <p>{`c) Customize redhat openshit to include shortcuts to all tools`}</p>
    <p>{`d) Finish the sysdig dashboard setip`}</p>
    <h3>{`10. Smoke test `}</h3>
    <p>{`Test access control.
Add personal id to SANDBOX-ONE-USER access group.
Log into IBM Cloud as the personal id and run the following test cases:`}</p>
    <ul>
      <li parentName="ul">{`Check only the resources assigned to sandbox: 1 cluster and 2 services under sandbox-team-one resource group should be visible.`}</li>
      <li parentName="ul">{`Try creating a service. You should get an access denied error.`}</li>
      <li parentName="ul">{`Go to Billing->Usage: You should be able to view, but should not be able to change anything.`}</li>
      <li parentName="ul">{`Try creating a resource group/access group. It should get permission errors.`}</li>
      <li parentName="ul">{`Go to Classic Infrastructure. Should give access denied error.`}</li>
      <li parentName="ul">{`Reboot a worker node. Should not be a allowed operation.`}</li>
      <li parentName="ul">{`Check if sysdig instance created by cloud native toolkit is collecting metrics from the resorces, and if it is not, set those up.`}</li>
      <li parentName="ul">{`Run pipelines of some starter kits and make sure they work.`}</li>
      <li parentName="ul">{`Check links from openshift and dashboard.`}</li>
    </ul>
    <h3>{`11.  Setup completed inventory solution with continous delivery (argocd)`}</h3>
    <h3>{`12. Install CP4A on the openshift cluster`}</h3>
    <ul>
      <li parentName="ul">{`Run schematics to install CP4A on openshift.`}</li>
      <li parentName="ul">{`Add Transformation Advisor (TA) link to the dashboard and openshift shortcut.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`igc tool-config --name ta --url url-for-ta
`}</code></pre>
    <ul>
      <li parentName="ul">{`Add shortcut to TA from openshift.`}</li>
    </ul>
    <h3>{`13. Database setup for Application Modernization`}</h3>
    <ul>
      <li parentName="ul">{`Create the Db2 Service from the IBM Cloud Catalogue.For Testing and demo purpose use Lite plan. For the workshop with developers hands-on, set it up with paid plan(Flex Plan).
`}<span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "43.75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAAB6klEQVQoz41RzY7SUBi9r4EbwASkQohATPhJiC9B4gO4cGnic7CoLIy4cu8OF0ajCQZGYh3DZNYzMcNQBjulf7ftLf053nsJs3Lhl5w2Ob093znnknK5jEqlglwuh8FggPF4jOFwCFVVMRqNJFT1FcZvXuPZ8xcgD96CPDkH6cxBHn8Aab0HefQO5P5LkHtPQarVKkqlEmq1GiaTCTRNw2w2w3w+x2KxwHK5xHf+Pjnh3OIXPs6u8EUz8OmHha8/TXw7o5guPUy13/g8PQVpNhsQLnu9HsIwxP9NxhH/8wtptVpQFAX9fh/6dgsaBvApRRRFSNMUQRDCcSh835cLBeeHMW5uKVw/hhckoBx+mOD6xgZRlIfI5/PodDq4NU1sNhusVitYloU4jrHf77Hli9brNQzD4IsYwiiBYdpwXQEHjIXIshTa6RlIvV5HsViUgo7jwLZt7HY7mFz8KGrb1h0n3AtBjzJ4nssFXZkm484vr7aiw6YUbLfboPywGCEiIOIxxqTLLMuQJIl0wtgelst41BgOje4im04EIm63UCigyx2atgPPD5DyH48jOrz+s5P9HQQhxS8uLrlrkeDApfwR8v5Jo9E4CHa7MpboSkQXl3B0p/NedV2XvOd5khPxRdei1yDwZY/i/F+agFSU9WDnggAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "CreateDB2",
            "title": "CreateDB2",
            "src": "/ibm-cloudnative-journey/static/8bc0105e05cacda3e1565d7a70348278/3cbba/05SandBoxRunBook.png",
            "srcSet": ["/ibm-cloudnative-journey/static/8bc0105e05cacda3e1565d7a70348278/7fc1e/05SandBoxRunBook.png 288w", "/ibm-cloudnative-journey/static/8bc0105e05cacda3e1565d7a70348278/a5df1/05SandBoxRunBook.png 576w", "/ibm-cloudnative-journey/static/8bc0105e05cacda3e1565d7a70348278/3cbba/05SandBoxRunBook.png 1152w", "/ibm-cloudnative-journey/static/8bc0105e05cacda3e1565d7a70348278/0b124/05SandBoxRunBook.png 1728w", "/ibm-cloudnative-journey/static/8bc0105e05cacda3e1565d7a70348278/6a339/05SandBoxRunBook.png 2048w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></li>
      <li parentName="ul">{`Provide the name for the service as “PlantsDB” and create the service.  Please note the service is also provisioned in the same region as the Openshift cluster to avoid latency.`}</li>
      <li parentName="ul">{`Once you create the service, Navigate to the `}<strong parentName="li">{`‘Service  Credential tab’`}</strong>{` in the left Nav and create a new credential for the Db2 service. Capture the details as this would be needed for the application.`}</li>
      <li parentName="ul">{`Now Click ‘Manage tab’ and click `}<strong parentName="li">{`‘Open Console’`}</strong>{`  button.`}</li>
      <li parentName="ul">{`Click on the Run option in the top left nav, which should open the SQL Editor.`}</li>
      <li parentName="ul">{`Execute the DDL Scripts to create the Database for the Plants application (Refer PlantsDB-create.sql in the box folder).`}</li>
      <li parentName="ul">{`Execute the Insert scripts to populate data for the Plants application (Refer Populate-PlantsDB.sql in the box folder).`}</li>
      <li parentName="ul">{`Navigate to the `}<strong parentName="li">{`‘connectioninfo’`}</strong>{` tab and select the option ‘without-sso’. Capture the Connection Details as well which is needed for the application`}</li>
    </ul>
    <h3>{`14.  Email the Participants`}</h3>
    <p>{`Send an email to all participants inviting them to the sandbox journeys.
`}<a parentName="p" {...{
        "href": "/ibm-cloudnative-journey/8525f1276a099e91c4f629b72ce2b1bb/emailtemplate.txt"
      }}>{`Email Template`}</a></p>
    <h3>{`15.  Skill Collection Matrix, Games`}</h3>
    <p>{`Setup menti templates for collecting skills of participants, fun games`}</p>
    <h3>{`16.  Feedback Collection`}</h3>
    <p>{`Setup funreto template for collecting feedback (What went right, what can be improved, Any other feedback)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      